export const engagementInAppMessageColorProfilesTags = "/engagement/in_app_message_color_profiles/tags";
